import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";

import { Success } from "../svg/svgImageList";
import { Dialog } from "../dialog/Dialog";
import { batchVideoAnalysisService } from "../../services/batch-processing/BatchVideoAnalysisService";
import { translationService } from "../../services/translation/TranslationService";
import { useLeavePagePrompt, LeavePagesEnum } from "../../helpers/useLeavePagePrompt";
import BatchVideoAnalysisProgressSnackbar from "./BatchVideoAnalysisProgressSnackbar";
import BatchVideoAnalysisStatus from "./batch-status/BatchVideoAnalysisStatus";

export default observer(function BatchVideoAnalysisStatusOverview() {
  const [setLeavePagePrompt] = useLeavePagePrompt();

  useEffect(() => {
    setLeavePagePrompt(
      batchVideoAnalysisService.statusModel.isProcessing,
      LeavePagesEnum.BatchVideoAnalysis
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchVideoAnalysisService.statusModel.isProcessing]);

  return (
    <>
    <BatchVideoAnalysisProgressSnackbar />
      <Dialog
        titleKey={"damages.BatchProcessingStatus.title.VideoAnalysis"}
        titleContext={{ itemsCount: batchVideoAnalysisService.statusModel.videoCount }}
        sidePosition
        isVisible={batchVideoAnalysisService.statusModel.displayStatusModal}
        onHide={batchVideoAnalysisService.statusModel.hideStatusBatchModal}
        buttonOk={{
          id: "status-video-analysis",
          textKey: "general.ok",
          action: batchVideoAnalysisService.statusModel.hideStatusBatchModal,
        }}
      >
        <BatchVideoAnalysisStatus />
      </Dialog>
      <Dialog
        titleKey="damages.BatchProcessingStatus.finalized.title"
        isVisible={batchVideoAnalysisService.statusModel.displayFinalizedModal}
        onHide={batchVideoAnalysisService.statusModel.hideStatusBatchModal}
        iconTitle={{
          svg: Success,
          width: 30,
          height: 30,
          className: "icon-success",
        }}
        buttonOk={{
          textKey: "general.upload.view-details",
          action: batchVideoAnalysisService.statusModel.showStatusBatchModal,
        }}
        buttonCancel={{
          textKey: "general.cancel",
          action: batchVideoAnalysisService.statusModel.hideStatusBatchModal,
        }}
        >
        <div className={"subtext-dialog"}>
          <div>
            {translationService.translate("damages.BatchProcessingStatus.finalized.message", {
              itemsCount: batchVideoAnalysisService.statusModel.videoCount,
            })}
          </div>
        </div>
      </Dialog>
    </>
  );
});
